export interface BreadcrumbItem {
  label: string;
  path?: string;
}

const routeMap: Record<string, { label: string; parent?: string }> = {
  "/dashboard": { label: "Início" },
  "/dashboard/correio": { label: "Correio interno", parent: "/dashboard" },
  "/dashboard/chat": { label: "Chat operacional", parent: "/dashboard" },
  "/correio-standalone": { label: "Correio (janela)", parent: "/" },
  "/chat-standalone": { label: "Chat (janela)", parent: "/" },
  "/acesso-externo/convite/aceite": { label: "Aceite de convite", parent: "/" },
  // Gestão Jurídica
  "/dashboard/juridica": { label: "Gestão Jurídica", parent: "/dashboard" },
  "/dashboard/juridica/processos": { label: "Processos", parent: "/dashboard/juridica" },
  "/dashboard/juridica/processos/kanban": { label: "Kanban & Agenda", parent: "/dashboard/juridica/processos" },
  "/dashboard/juridica/controle": { label: "Painel de Controle", parent: "/dashboard/juridica" },
  "/dashboard/juridica/processos/agenda": { label: "Agenda", parent: "/dashboard/juridica/processos" },
  "/dashboard/juridica/processos/publicacoes": { label: "Publicações", parent: "/dashboard/juridica/processos" },
  "/dashboard/juridica/processos/relatorios": { label: "Relatórios", parent: "/dashboard/juridica/processos" },
  "/dashboard/juridica/processos/por-cliente": { label: "Por Cliente", parent: "/dashboard/juridica/processos" },
  "/dashboard/juridica/processos/por-advogado": { label: "Por Advogado", parent: "/dashboard/juridica/processos" },
  "/dashboard/juridica/processos/por-equipe": { label: "Por Equipe", parent: "/dashboard/juridica/processos" },
  "/dashboard/juridica/ia/peticoes": { label: "Petições por IA", parent: "/dashboard/juridica" },
  "/dashboard/juridica/ia/contratos": { label: "Contratos por IA", parent: "/dashboard/juridica" },
  "/dashboard/juridica/ia/pareceres": { label: "Pareceres Jurídicos", parent: "/dashboard/juridica" },
  "/dashboard/juridica/ia/procuracoes": { label: "Procurações por IA", parent: "/dashboard/juridica" },
  "/dashboard/juridica/ia/propostas": { label: "Propostas IA", parent: "/dashboard/juridica" },
  "/dashboard/juridica/ia/valometria-trabalhista": { label: "Valometria trabalhista", parent: "/dashboard/juridica" },
  "/dashboard/juridica/formatacao": { label: "Formatação", parent: "/dashboard/juridica" },
  "/dashboard/juridica/formatacao/manual": { label: "Manual", parent: "/dashboard/juridica/formatacao" },
  "/dashboard/juridica/formatacao/editor": { label: "Editor", parent: "/dashboard/juridica/formatacao" },
  "/dashboard/juridica/processos/novo": { label: "Novo Processo", parent: "/dashboard/juridica/processos" },
  "/dashboard/juridica/calculos": { label: "Hub Cálculos", parent: "/dashboard/juridica" },
  "/dashboard/juridica/calculos/trabalhista": { label: "Cálculos Trabalhistas", parent: "/dashboard/juridica/calculos" },
  "/dashboard/juridica/calculos/tributario": { label: "Cálculos Tributários", parent: "/dashboard/juridica/calculos" },
  "/dashboard/juridica/calculos/monetario": { label: "Correção Monetária", parent: "/dashboard/juridica/calculos" },
  "/dashboard/juridica/calculos/prazos": { label: "Prazos", parent: "/dashboard/juridica/calculos" },
  "/dashboard/juridica/calculos/sped": { label: "Importação SPED", parent: "/dashboard/juridica/calculos" },
  "/dashboard/juridica/calculos/tributario-ia": { label: "IA Tributária", parent: "/dashboard/juridica/calculos" },
  "/dashboard/juridica/calculos/parametros": { label: "Parâmetros Tributários", parent: "/dashboard/juridica/calculos" },
  "/dashboard/juridica/calculos/regras": { label: "Regras Trabalhistas", parent: "/dashboard/juridica/calculos" },
  "/dashboard/juridica/calculos/manual": { label: "Manual", parent: "/dashboard/juridica/calculos" },
  "/dashboard/juridica/calculos/monetario/simples": { label: "Cálculo Simples", parent: "/dashboard/juridica/calculos/monetario" },
  "/dashboard/juridica/calculos/monetario/comparativo": { label: "Comparativo", parent: "/dashboard/juridica/calculos/monetario" },
  "/dashboard/juridica/calculos/monetario/salvos": { label: "Meus Cálculos", parent: "/dashboard/juridica/calculos/monetario" },
  "/dashboard/juridica/calculos/monetario/indices": { label: "Índices Econômicos", parent: "/dashboard/juridica/calculos/monetario" },
  "/dashboard/juridica/meus-documentos": { label: "Meus Documentos", parent: "/dashboard/juridica" },
  "/dashboard/juridica/documentos": { label: "Todos os Documentos", parent: "/dashboard/juridica" },
  "/dashboard/juridica/arquivo": { label: "Arquivo Jurídico", parent: "/dashboard/juridica" },
  "/dashboard/juridica/processos-ext": { label: "Processos extrajudiciais", parent: "/dashboard/juridica" },
  "/dashboard/juridica/processos-ext/:id": { label: "Ficha do processo", parent: "/dashboard/juridica/processos-ext" },
  "/dashboard/juridica/procedimentos": { label: "Procedimentos", parent: "/dashboard/juridica" },
  "/dashboard/juridica/procedimentos/:id": { label: "Ficha do procedimento", parent: "/dashboard/juridica/procedimentos" },
  "/dashboard/juridica/processos-adm": { label: "Processos Administrativos", parent: "/dashboard/juridica" },
  "/dashboard/juridica/processos-adm/lista": { label: "Lista", parent: "/dashboard/juridica/processos-adm" },
  "/dashboard/juridica/processos-adm/por-cliente": { label: "Por Cliente", parent: "/dashboard/juridica/processos-adm" },
  "/dashboard/juridica/processos-adm/:id": { label: "Ficha do processo", parent: "/dashboard/juridica/processos-adm" },
  "/dashboard/juridica/gestao/tipos-compromisso": { label: "Tipos de Compromisso", parent: "/dashboard/juridica" },
  "/dashboard/juridica/gestao/timesheet": { label: "Timesheet", parent: "/dashboard/juridica" },
  "/dashboard/juridica/gestao/valometria": { label: "Valometria", parent: "/dashboard/juridica" },
  "/dashboard/juridica/gestao/producao": { label: "Produção", parent: "/dashboard/juridica" },
  "/dashboard/juridica/gestao/precificador-pro": { label: "Precificador Pro", parent: "/dashboard/juridica" },
  "/dashboard/juridica/gestao/descoberta-automatica": { label: "Descoberta Automática", parent: "/dashboard/juridica" },
  "/dashboard/juridica/ia/maturidade": { label: "Maturidade IA", parent: "/dashboard/juridica" },
  // Gestão Administrativa
  "/dashboard/administrativa": { label: "Gestão Administrativa", parent: "/dashboard" },
  "/dashboard/administrativa/ia/contratos-ferrugini": { label: "Contratos Ferrugini IA", parent: "/dashboard/administrativa" },
  "/dashboard/administrativa/ia/respostas": { label: "Resposta ao Cliente IA", parent: "/dashboard/administrativa" },
  "/dashboard/administrativa/ia/tipos": { label: "Tipos de Documento", parent: "/dashboard/administrativa" },
  "/dashboard/administrativa/normas": { label: "Base de Conhecimento", parent: "/dashboard/administrativa" },
  "/dashboard/administrativa/normas/ia": { label: "IA Normas", parent: "/dashboard/administrativa/normas" },
  "/dashboard/administrativa/normas/checklist": { label: "Checklists e Manuais", parent: "/dashboard/administrativa/normas" },
  "/dashboard/administrativa/normas/novo": { label: "Novo Documento", parent: "/dashboard/administrativa/normas" },
  "/dashboard/administrativa/sistema": { label: "Sistema", parent: "/dashboard/administrativa" },
  "/dashboard/administrativa/configuracoes": { label: "Perfil", parent: "/dashboard/administrativa/sistema" },
  "/dashboard/administrativa/relatorios": { label: "Relatórios", parent: "/dashboard/administrativa/sistema" },
  "/dashboard/administrativa/manual": { label: "Manual", parent: "/dashboard/administrativa/sistema" },
  "/dashboard/administrativa/roadmap": { label: "Em Breve", parent: "/dashboard/administrativa/sistema" },
  "/dashboard/administrativa/sistema/ia": { label: "Assistente IA", parent: "/dashboard/administrativa/sistema" },
  "/dashboard/administrativa/sistema/ia/meu-perfil": { label: "Meu Perfil de IA", parent: "/dashboard/administrativa/sistema/ia" },
  "/dashboard/administrativa/sistema/ia/chat": { label: "Chat", parent: "/dashboard/administrativa/sistema/ia" },
  "/dashboard/administrativa/sistema/ia/base": { label: "Base Geral de Dados", parent: "/dashboard/administrativa/sistema/ia" },
  "/dashboard/administrativa/sistema/ia/modulos": { label: "Base por Módulos", parent: "/dashboard/administrativa/sistema/ia" },
  "/dashboard/administrativa/sistema/ia/modulos/financeiro": { label: "Financeiro", parent: "/dashboard/administrativa/sistema/ia/modulos" },
  "/dashboard/administrativa/sistema/ia/modulos/audit-tributaria": { label: "Auditoria Tributária", parent: "/dashboard/administrativa/sistema/ia/modulos" },
  "/dashboard/administrativa/sistema/ia/modulos/audit-trabalhista": { label: "Auditoria Trabalhista", parent: "/dashboard/administrativa/sistema/ia/modulos" },
  "/dashboard/administrativa/sistema/ia/modulos/peticoes": { label: "Petições", parent: "/dashboard/administrativa/sistema/ia/modulos" },
  "/dashboard/administrativa/sistema/ia/modulos/contratos": { label: "Contratos", parent: "/dashboard/administrativa/sistema/ia/modulos" },
  "/dashboard/administrativa/sistema/ia/modulos/pareceres": { label: "Pareceres", parent: "/dashboard/administrativa/sistema/ia/modulos" },
  "/dashboard/administrativa/sistema/ia/instrucoes": { label: "Instruções à IA", parent: "/dashboard/administrativa/sistema/ia" },
  "/dashboard/administrativa/sistema/ia/permissoes-alimentacao": { label: "Permissões de Alimentação", parent: "/dashboard/administrativa/sistema/ia" },
  "/dashboard/administrativa/sistema/ia/padaria/convencoes": { label: "Padaria — Convenções", parent: "/dashboard/administrativa/sistema/ia" },
  "/dashboard/administrativa/admin": { label: "Administração", parent: "/dashboard/administrativa/sistema" },
  "/dashboard/administrativa/admin/usuarios": { label: "Usuários", parent: "/dashboard/administrativa/admin" },
  "/dashboard/administrativa/admin/permissoes": { label: "Permissões", parent: "/dashboard/administrativa/admin" },
  "/dashboard/administrativa/admin/aniversarios": { label: "Aniversários", parent: "/dashboard/administrativa/admin" },
  "/dashboard/administrativa/admin/datas": { label: "Datas Importantes", parent: "/dashboard/administrativa/admin" },
  "/dashboard/administrativa/admin/historico": { label: "Histórico", parent: "/dashboard/administrativa/admin" },
  "/dashboard/administrativa/admin/feedback": { label: "Feedback", parent: "/dashboard/administrativa/admin" },
  "/dashboard/administrativa/admin/ranking": { label: "Ranking", parent: "/dashboard/administrativa/admin" },
  "/dashboard/administrativa/admin/backup": { label: "Backup", parent: "/dashboard/administrativa/admin" },
  "/dashboard/administrativa/arquivo": { label: "Arquivo Administrativo", parent: "/dashboard/administrativa" },
  // Instituições
  "/dashboard/institutions": { label: "Instituições", parent: "/dashboard" },
  "/dashboard/institutions/new": { label: "Nova Instituição", parent: "/dashboard/institutions" },
  "/dashboard/institutions/manual-cobranca-condominial": {
    label: "Manual — E-mails de cobrança",
    parent: "/dashboard/institutions",
  },
  "/dashboard/institutions/:id": { label: "Instituição", parent: "/dashboard/institutions" },
  "/dashboard/institutions/:id/padaria/funcionarios/:funcId": {
    label: "Funcionário",
    parent: "/dashboard/institutions/:id",
  },
  // Finance
  "/dashboard/finance-home": { label: "Gestão Financeira", parent: "/dashboard" },
  "/dashboard/finance/data": { label: "Inclusão de Dados", parent: "/dashboard/finance-home" },
  "/dashboard/finance/entries": { label: "Contratos e Lançamentos", parent: "/dashboard/finance/data" },
  "/dashboard/finance/clients": { label: "Clientes", parent: "/dashboard/finance/data" },
  "/dashboard/finance/suppliers": { label: "Fornecedores", parent: "/dashboard/finance/data" },
  "/dashboard/finance/professionals": { label: "Profissionais", parent: "/dashboard/finance/data" },
  "/dashboard/finance/contracts": { label: "Contratos", parent: "/dashboard/finance/data" },
  "/dashboard/finance/reports": { label: "Relatórios Financeiros", parent: "/dashboard/finance-home" },
  "/dashboard/finance": { label: "Fluxo de Caixa", parent: "/dashboard/finance/reports" },
  "/dashboard/finance/production": { label: "Produção", parent: "/dashboard/finance/reports" },
  "/dashboard/finance/closing": { label: "Fechamento", parent: "/dashboard/finance/reports" },
  "/dashboard/finance/profitability": { label: "Rentabilidade", parent: "/dashboard/finance/reports" },
  "/dashboard/finance/overdue": { label: "Inadimplência", parent: "/dashboard/finance/reports" },
  "/dashboard/finance/ai": { label: "IA Financeira", parent: "/dashboard/finance-home" },
  "/dashboard/finance/assets": { label: "Ativos", parent: "/dashboard/finance/data" },
  "/dashboard/finance/passivos": { label: "Passivos", parent: "/dashboard/finance/data" },
  "/dashboard/finance/clients/form": { label: "Formulário de Cliente", parent: "/dashboard/finance/clients" },
  "/dashboard/finance/contracts-registered": { label: "Contratos Registrados", parent: "/dashboard/finance/data" },
  "/dashboard/finance-home/manual": { label: "Manual", parent: "/dashboard/finance-home" },
  // Audits Hub
  "/dashboard/audits": { label: "Auditoria e Planejamento", parent: "/dashboard" },
  // Tax Audit
  "/dashboard/audit": { label: "Auditoria Tributária", parent: "/dashboard/audits" },
  "/dashboard/audit/companies": { label: "Empresas", parent: "/dashboard/audit" },
  "/dashboard/audit/import": { label: "Importação", parent: "/dashboard/audit" },
  "/dashboard/audit/crosscheck": { label: "Cruzamento de Dados", parent: "/dashboard/audit" },
  "/dashboard/audit/findings": { label: "Inconsistências", parent: "/dashboard/audit" },
  "/dashboard/audit/credits": { label: "Recuperação de Créditos", parent: "/dashboard/audit" },
  "/dashboard/audit/dashboard": { label: "Dashboard", parent: "/dashboard/audit" },
  "/dashboard/audit/reports": { label: "Relatórios", parent: "/dashboard/audit" },
  "/dashboard/audit/settings": { label: "Configurações", parent: "/dashboard/audit" },
  "/dashboard/audit/manual": { label: "Manual", parent: "/dashboard/audit" },
  "/dashboard/audit/ai": { label: "IA Tributária", parent: "/dashboard/audit" },
  // Labor Audit
  "/dashboard/labor-audit": { label: "Auditoria Trabalhista", parent: "/dashboard/audits" },
  "/dashboard/labor-audit/companies": { label: "Empresas", parent: "/dashboard/labor-audit" },
  "/dashboard/labor-audit/import": { label: "Importação", parent: "/dashboard/labor-audit" },
  "/dashboard/labor-audit/payroll": { label: "Validação de Folha", parent: "/dashboard/labor-audit" },
  "/dashboard/labor-audit/esocial": { label: "Compliance eSocial", parent: "/dashboard/labor-audit" },
  "/dashboard/labor-audit/findings": { label: "Inconformidades", parent: "/dashboard/labor-audit" },
  "/dashboard/labor-audit/risks": { label: "Riscos e Passivos", parent: "/dashboard/labor-audit" },
  "/dashboard/labor-audit/dashboard": { label: "Dashboard", parent: "/dashboard/labor-audit" },
  "/dashboard/labor-audit/reports": { label: "Relatórios", parent: "/dashboard/labor-audit" },
  "/dashboard/labor-audit/manual": { label: "Manual", parent: "/dashboard/labor-audit" },
  "/dashboard/labor-audit/ai": { label: "IA Trabalhista", parent: "/dashboard/labor-audit" },
  // Tax Transition
  "/dashboard/audits/tax-transition/changes": { label: "Mudanças IBS/CBS", parent: "/dashboard/audits" },
  "/dashboard/audits/tax-transition/ai": { label: "IA Tributária", parent: "/dashboard/audits" },
  "/dashboard/audits/tax-transition/knowledge": { label: "Base de Conhecimento", parent: "/dashboard/audits" },
  // Agenda e Arquivo
  "/dashboard/agenda": { label: "Kanban & Agenda", parent: "/dashboard" },
  "/dashboard/arquivo": { label: "Arquivo Digital", parent: "/dashboard" },
};

const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

function resolveRouteKey(pathname: string): string {
  if (routeMap[pathname]) return pathname;
  const parts = pathname.split("/").filter(Boolean);
  if (
    parts[0] === "dashboard" &&
    parts[1] === "institutions" &&
    parts.length === 6 &&
    parts[3] === "padaria" &&
    parts[4] === "funcionarios" &&
    UUID_RE.test(parts[2] ?? "") &&
    UUID_RE.test(parts[5] ?? "")
  ) {
    return "/dashboard/institutions/:id/padaria/funcionarios/:funcId";
  }
  if (
    parts[0] === "dashboard" &&
    parts[1] === "institutions" &&
    parts.length === 3 &&
    UUID_RE.test(parts[2] ?? "")
  ) {
    return "/dashboard/institutions/:id";
  }
  if (parts[0] === "dashboard" && parts[1] === "juridica" && parts.length === 4) {
    if (parts[2] === "processos-ext" && UUID_RE.test(parts[3])) {
      return "/dashboard/juridica/processos-ext/:id";
    }
    if (parts[2] === "procedimentos" && UUID_RE.test(parts[3])) {
      return "/dashboard/juridica/procedimentos/:id";
    }
    if (parts[2] === "processos-adm" && UUID_RE.test(parts[3])) {
      return "/dashboard/juridica/processos-adm/:id";
    }
  }
  return pathname;
}

export function getBreadcrumbs(pathname: string): BreadcrumbItem[] {
  const crumbs: BreadcrumbItem[] = [];
  let current: string | undefined = resolveRouteKey(pathname);

  while (current) {
    const entry = routeMap[current];
    if (!entry) break;
    crumbs.unshift({ label: entry.label, path: current });
    current = entry.parent;
  }

  // Remove link from last item (current page)
  if (crumbs.length > 0) {
    crumbs[crumbs.length - 1] = { label: crumbs[crumbs.length - 1].label };
  }

  return crumbs;
}
